<script setup>
import { useRoute } from 'vue-router';
import { useDashboardStore } from '~/dashboard/store/dashboard.store.js';
import TerraBarcodeScan from '~/terra/components/barcode-scan/terra-barcode-scan.vue';
import { useTerraStore } from '~/terra/store/terra.store.js';

const dashboard_store = useDashboardStore();
const store_name = `dashboard_scan_report_${dashboard_store.current_dashboard?.uid}`;
const terra_store = useTerraStore(store_name);
onMounted(async () => {
  // Setting it in store itself
  if (!terra_store.container) {
    await terra_store.set_container({
      uid: dashboard_store.current_dashboard?.report_data?.data?.id,
      type: 'terra',
    });
  }
});
</script>

<template>
  <div>
    <TerraBarcodeScan v-if="terra_store.container" :terra_store_name="store_name" :is-scan-report-dashboard="true" />
  </div>
</template>
